import React from 'react';
import { DefaultCommentInterface } from '../../interfaces/Comments';
import ListComponent from '../../utils/ListComponent';
import CommentItem from '../boxes/CommentItem';
import CommentItemLoading from '../loading/CommentItemLoading';

interface CommentsProps {
  comments?: DefaultCommentInterface[]; // optional
  comment_count?: number;
}

const CommentList = ({ comments = [], comment_count = 0 }: CommentsProps) => {
  // Loading state: comments undefined
  const isLoading = comments.length === 0 && comment_count > 0;

  return (
    <>
      {isLoading ? (
        <CommentItemLoading count={Math.min(comment_count, 2)} />
      ) : (
        <ul className="mt-4 space-y-8">
          <ListComponent
            data={comments}
            renderItem={(comment) => (
              <CommentItem
                name={comment.com_geb_naam}
                date={comment.updated_at}
                comment={comment.com_commentaar}
                attachments={comment.attachments ?? []}
                user={{
                  med_foto: comment.med_foto,
                  med_naam: comment.med_naam || '',
                  med_id: comment.med_id || 0,
                  med_isOnline: comment.med_isOnline || false,
                  med_afdeling: comment.med_afdeling || '',
                }}
              />
            )}
          />
        </ul>
      )}
    </>
  );
};

export default CommentList;
